export default "__VITE_ASSET__DWttPpRY__"